<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :msgStCd="item.msgStCd"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import list from "./list.vue"
export default {
  components: {
    list
  },
  data() {
    return {
      tabData: [
        {
          name: "待读通知",
          key: "transferNoread",
          comp: list,
          msgStCd: 0,
        },
        {
          name: "已读通知",
          key: "transferReaded",
          comp: list,
          msgStCd: 1
        }
      ],
      tabCur: "transferNoread"
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/message/transferNotice/index.vue